import HotelOutlinedIcon from '@mui/icons-material/HotelOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import type { ModuleDefinition } from '../../app/moduleRegistry';
import { ReservationDetailPage } from '../../components/ReservationDetailPage';
import { HOTEL_CAPS } from '../../components/reservation/capabilities';
import HotelFlowPage from './pages/HotelFlowPage';
import HotelReservationsPage from './pages/HotelReservationsPage';

/** Clicking a PNR/ticket number in "Rezervasyon Listesi" navigates to
 *  `hotel/reservations/:identifier` — the shared `ReservationDetailPage` (see
 *  ../../components/ReservationDetailPage.tsx), re-fetched fresh via `Entry/Find`.
 *  `HOTEL_CAPS.cancel = 'hotel'` wires İptal Et to `Hotel/GetReservationCancel`
 *  (reservationNumber resolution is best-effort — see docs/backend-requirements.md). */
export const hotelModule: ModuleDefinition = {
  routes: [
    { path: 'hotel', element: <HotelFlowPage /> },
    { path: 'hotel/reservations', element: <HotelReservationsPage /> },
    { path: 'hotel/reservations/:identifier', element: <ReservationDetailPage capabilities={HOTEL_CAPS} /> },
  ],
  menuItems: [
    { label: 'Arama', path: 'hotel', icon: <HotelOutlinedIcon />, group: 'Otel', groupIcon: <HotelOutlinedIcon /> },
    {
      label: 'Rezervasyon Listesi',
      path: 'hotel/reservations',
      icon: <ListAltOutlinedIcon />,
      group: 'Otel',
    },
  ],
};
